
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[communityPath]/[topicPath]/[postPath]",
      function () {
        return require("private-next-pages/community/[communityPath]/[topicPath]/[postPath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[communityPath]/[topicPath]/[postPath]"])
      });
    }
  